export default [
  { value: true, key: "dependents.datatable.disability.yes" },
  { value: false, key: "dependents.datatable.disability.no" },
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/dependents/enums/dependentDisability.js